import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  DialogContent,
  TextField,
  Dialog,
} from "@mui/material";
import { UseAddOrder } from "./UseAddOrder";
import { toMoney } from "../../util/Utils";
import copy from "copy-text-to-clipboard";
import { useSnackbar } from "notistack";

export default function SetOrderDetails(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { CheckOrder, SaveOrder, validate } = UseAddOrder();
  const [openDialogeSubmit, setOpenDialogeSubmit] = useState({
    show: false,
    orderID: undefined,
  });
  const [openDialogeCode, setOpenDialogeCode] = useState(false);
  const [checkOK, setCheckOK] = useState(false);
  const [orderID, setOrderID] = useState(
    props.state && props.state.orderID ? props.state.orderID : ""
  );
  const [discountState, setDiscountState] = useState({
    OrderID: props.orderID,
    discountcode: undefined,
  });
  const { AddDiscountCode } = UseAddOrder();

  return (
    <Box
      sx={{
        border: "1px solid rgba(224, 224, 224, 1)",
        boxShadow: 4,
        zIndex: 1000,
        p: 2,
        borderRadius: 3,
        position: "sticky",
        top: "-5px",
      }}
    >
      <Dialog
        fullWidth
        maxWidth="xs"
        // onClose={() => {
        //   setOpenDialogeSubmit(false);
        // }}
        open={openDialogeSubmit.show}
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography variant="body1">سفارش جدید ثبت شد </Typography>
            <Box sx={{ my: 2, display: "flex", alignItems: "center" }}>
              <Typography sx={{ mr: 1 }} variant="body1">
                شماره سفارش :
              </Typography>
              <Typography color="secondary.main" variant="body1">
                {openDialogeSubmit.show && openDialogeSubmit.orderID
                  ? openDialogeSubmit.orderID
                  : ""}
              </Typography>
            </Box>
            <Button
              variant="outlined"
              onClick={() => {
                setOpenDialogeSubmit({ ...openDialogeSubmit, show: false });
                props.setRow();
                setDiscountState({
                  OrderID: undefined,
                  discountcode: undefined,
                });
                props.setExpanded("panel1");
                props.setState({
                  OrderID: undefined,
                  address: undefined,
                  addressTitle: undefined,
                  cityID: undefined,
                  description: undefined,
                  firstName: undefined,
                  lastName: undefined,
                  mobile: undefined,
                  postCode: undefined,
                  provinceID: undefined,
                  reciver: undefined,
                  deliveryID: undefined,
                  deliveryType: undefined,
                  phone: undefined,
                  paymentType: undefined,
                  bankID: null,
                  offlinePayCode: undefined,
                  SendFactor: false,
                  Confidential: false,
                  SendSMS: false,
                  notUsecraditDiscount: false,
                });
              }}
            >
              بستن
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog
        fullWidth
        maxWidth="xs"
        onClose={() => {
          setOpenDialogeCode(false);
        }}
        open={openDialogeCode}
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <TextField
              fullWidth
              id="outlined-basic"
              value={
                discountState.discountcode ? discountState.discountcode : ""
              }
              sx={{
                input: {
                  direction: "rtl",
                },
                width: "80%",
              }}
              label="کد تخفیف"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setDiscountState({
                  OrderID: props.orderID,
                  discountcode: evt.target.value,
                });
              }}
              InputProps={{
                autoComplete: "off",
                inputProps: {
                  min: 1,
                },
              }}
            />
            <Box sx={{ mt: 2 }}>
              <Button
                sx={{ mr: 2 }}
                variant="contained"
                onClick={() => {
                  AddDiscountCode(discountState, (callback) => {
                    setOpenDialogeCode(false);
                    props.setRow(callback);
                  });
                }}
              >
                بررسی
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  setOpenDialogeCode(false);
                }}
              >
                انصراف
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      <Box>
        <Typography sx={{ textAlign: "center" }} variant="body1">
          اطلاعات پرداخت
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1,
        }}
      >
        <Typography variant="body2">جمع کل : </Typography>
        <Typography variant="body1">
          {props.row && props.row.totalCost !== 0
            ? toMoney(props.row.totalCost)
            : 0}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1,
        }}
      >
        <Typography variant="body2">هزینه ارسال : </Typography>
        <Typography variant="body1">
          {props.row && props.row.deliveryCost !== 0
            ? toMoney(props.row.deliveryCost)
            : 0}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1,
        }}
      >
        <Typography variant="body2">تخفیف اعتباری : </Typography>
        <Typography variant="body1">
          {props.row && props.row.creditDiscount !== 0
            ? toMoney(props.row.creditDiscount)
            : 0}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1,
        }}
      >
        <Typography variant="body2">تخفیف مستقیم : </Typography>
        <Typography variant="body1">
          {props.row && props.row.directDiscount !== 0
            ? toMoney(props.row.directDiscount)
            : 0}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1,
        }}
      >
        <Typography variant="body2">کد تخفیف : </Typography>
        <Typography variant="body1">
          {props.row && props.row.codeDiscount && props.row.codeDiscount !== 0
            ? toMoney(props.row.codeDiscount)
            : 0}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1,
        }}
      >
        <Typography variant="body2">مبلغ قابل پرداخت : </Typography>
        <Typography variant="body1">
          {props.row && props.row.totalPayCost && props.row.totalPayCost !== 0
            ? toMoney(props.row.totalPayCost)
            : 0}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          mt: 2,
          mx: 2,
        }}
      >
        <Button
          sx={{ mb: 2 }}
          variant="contained"
          disabled={!props.orderID ? true : false}
          onClick={() => {
            var sendModel = {
              OrderID: props.orderID,
              paymentType: props.state.paymentType,
              // bankID: props.state.bankID,
              offlinePayCode: props.state.offlinePayCode,
              SendFactor: props.state.SendFactor,
              Confidential: props.state.Confidential,
              SendSMS: props.state.SendSMS,
              notUsecraditDiscount: props.state.notUsecraditDiscount,
            };
            // setOpenDialogeSubmit(true);
            // return;
            if (
              props.row &&
              props.state.deliveryType == "ارسال سریع با پیک موتوری" &&
              (!props.row.deliveryCost || props.row.deliveryCost == 0)
            ) {
              enqueueSnackbar("لطفا هزینه ارسال را محاسبه کنید", {
                variant: "error",
                autoHideDuration: 2000,
                preventDuplicate: true,
              });
              return;
            }
            if (validate(props.state, props.setErrorState) == 200) {
              CheckOrder(props.state, (callBack) => {
                props.setRow(callBack);
                SaveOrder(sendModel, (callBack) => {
                  // return;
                  copy(callBack.orderID && callBack.orderID.toString());
                  if (copy(callBack.orderID && callBack.orderID.toString())) {
                    enqueueSnackbar("شماره سفارش در کلیپ بورد شما کپی شد ", {
                      variant: "info",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                  }
                  setOpenDialogeSubmit({
                    show: true,
                    orderID: callBack.orderID,
                  });
                });
              });
            }
          }}
        >
          ثبت
        </Button>
        <Button
          disabled={!props.orderID ? true : false}
          sx={{ mb: 2 }}
          color="secondary"
          variant="contained"
          onClick={() => {
            if (
              props.row &&
              props.state.deliveryType == "ارسال سریع با پیک موتوری" &&
              (!props.row.deliveryCost || props.row.deliveryCost == 0)
            ) {
              enqueueSnackbar("لطفا هزینه ارسال را محاسبه کنید", {
                variant: "error",
                autoHideDuration: 2000,
                preventDuplicate: true,
              });
              return;
            }
            if (validate(props.state, props.setErrorState) == 200) {
              CheckOrder(props.state, (callBack) => {
                props.setRow(callBack);
                setOrderID(callBack.orderID);
                setCheckOK(true);
              });
            }
          }}
        >
          محاسبه
        </Button>
        <Button
          disabled={!props.orderID ? true : false}
          color="secondary"
          variant="outlined"
          onClick={() => {
            setOpenDialogeCode(true);
          }}
        >
          کد تخفیف
        </Button>
      </Box>
    </Box>
  );
}
